// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy_container__1KJf1","dark":"privacy_dark__1BQNQ"};